import React from 'react';
import { SVGTextRenderer } from '@/layers/text-layer';
import { type VectorLayerProps } from '../types';
import { transformToTextLayer } from '../utils';

type Props = VectorLayerProps;

const TextContent: React.FC<Props> = ({ layer, identity, isNavigator }) => {
    const textLayer = transformToTextLayer(layer);

    return <SVGTextRenderer layer={textLayer} identity={identity} isNavigator={isNavigator} />;
};

export default TextContent;
